module.exports = __webpack_public_path__ + "static/media/ensuite_light.f92fe123.jpg";